import type { ValueSet } from '@medplum/fhirtypes';

const VITAL_SIGNS_VALUE_SET_URL = 'http://liza.health/fhir/ValueSet/vital-signs';

export interface VitalSignConfig {
  code: string;
  display: string;
}

export const VITAL_SIGN_CONFIGS: VitalSignConfig[] = [
  { code: '8867-4', display: 'Heart rate' },
  { code: '85354-9', display: 'Blood pressure' },
  { code: '8310-5', display: 'Body temperature' },
  { code: '29463-7', display: 'Body weight' },
  { code: '8302-2', display: 'Body height' },
  { code: '39156-5', display: 'Body mass index' },
  { code: '59408-5', display: 'Oxygen saturation' },
  { code: '9279-1', display: 'Respiratory rate' },
  { code: '9843-4', display: 'Head circumference' },
  { code: '8280-0', display: 'Waist circumference' },
];

export const vitalSignsValueSet: ValueSet = {
  resourceType: 'ValueSet',
  url: VITAL_SIGNS_VALUE_SET_URL,
  name: 'liza-vital-signs',
  title: 'Liza Vital Signs',
  identifier: [{ system: 'urn:ietf:rfc:3986', value: VITAL_SIGNS_VALUE_SET_URL }],
  status: 'active',
  compose: {
    include: [
      {
        system: 'http://loinc.org',
        concept: VITAL_SIGN_CONFIGS.map(({ code, display }) => ({ code, display })),
      },
    ],
  },
};
